if (!window.cbmProductCardReady) {
  window.cbmProductCardReady = true;

  const closePanel = (panel) => {
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    const opener = document.querySelector(`[data-pcard-open][aria-controls="${panel.id}"]`);
    if (opener) opener.setAttribute('aria-expanded', 'false');
  };

  // The panel's own submit button is hidden; the card button shows its loading state instead.
  const mirrorLoading = (source, target) => {
    if (source.dataset.pcardMirrored) return;
    source.dataset.pcardMirrored = 'true';
    const spinner = target.querySelector('.loading__spinner');
    new MutationObserver(() => {
      const loading = source.classList.contains('loading');
      target.classList.toggle('loading', loading);
      target.setAttribute('aria-busy', String(loading));
      if (spinner) spinner.classList.toggle('hidden', !loading);
    }).observe(source, { attributes: true, attributeFilter: ['class'] });
  };

  const closeAllPanels = (except) => {
    document.querySelectorAll('[data-pcard-panel].is-open').forEach((panel) => {
      if (panel !== except) closePanel(panel);
    });
  };

  // Delegated so cards re-rendered by AJAX filtering keep working.
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-pcard-open]');
    if (opener) {
      const panel = document.getElementById(opener.getAttribute('aria-controls'));
      if (!panel) return;
      if (panel.classList.contains('is-open')) {
        if (opener.classList.contains('loading')) return;
        const form = panel.querySelector('form');
        const submit = panel.querySelector('[type="submit"]');
        if (!form || !submit) return;
        mirrorLoading(submit, opener);
        form.requestSubmit ? form.requestSubmit() : submit.click();
        return;
      }
      closeAllPanels(panel);
      panel.classList.add('is-open');
      opener.setAttribute('aria-expanded', 'true');
      const focusTarget = panel.querySelector('[data-pcard-chip].is-selected') || panel.querySelector('[data-pcard-chip]:not([disabled])');
      if (focusTarget) setTimeout(() => focusTarget.focus({ preventScroll: true }), 120);
      return;
    }

    const chip = event.target.closest('[data-pcard-chip]');
    if (chip) {
      if (chip.disabled) return;
      const panel = chip.closest('[data-pcard-panel]');
      panel.querySelectorAll('[data-pcard-chip]').forEach((c) => {
        const on = c === chip;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-checked', String(on));
      });
      const input = panel.querySelector('[data-pcard-variant]');
      if (input) input.value = chip.dataset.variantId;
      const opener = document.querySelector(`[data-pcard-open][aria-controls="${panel.id}"]`);
      [panel, opener].forEach((scope) => {
        const price = scope && scope.querySelector('[data-pcard-price]');
        if (price && chip.dataset.price) price.textContent = chip.dataset.price;
      });
      return;
    }

    const closer = event.target.closest('[data-pcard-close]');
    if (closer) {
      const panel = closer.closest('[data-pcard-panel]');
      closePanel(panel);
      const trigger = document.querySelector(`[data-pcard-open][aria-controls="${panel.id}"]`);
      if (trigger) trigger.focus();
      return;
    }

    if (!event.target.closest('[data-pcard-panel]')) closeAllPanels();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const panel = event.target.closest && event.target.closest('[data-pcard-panel].is-open');
    if (!panel) return;
    closePanel(panel);
    const trigger = document.querySelector(`[data-pcard-open][aria-controls="${panel.id}"]`);
    if (trigger) trigger.focus();
  });

  // Scroll doesn't bubble, so listen in the capture phase to catch every card's image strip.
  document.addEventListener(
    'scroll',
    (event) => {
      const track = event.target;
      if (!(track instanceof Element) || !track.matches('[data-pcard-track]')) return;
      const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      const dots = track.parentElement.querySelectorAll('.pcard__dot');
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    },
    { capture: true, passive: true }
  );

  const onCartUpdate = () => closeAllPanels();
  const subscribeToCart = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
      return true;
    }
    return false;
  };
  if (!subscribeToCart()) document.addEventListener('DOMContentLoaded', subscribeToCart, { once: true });
}
